exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2WBLh{background-color:#fff;margin-top:20px;margin-bottom:20px;z-index:1}._1BJXD,._2WBLh{position:relative}._1BJXD{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:nowrap;flex-wrap:nowrap;padding-bottom:15px}._3yFbM{height:1px;background-color:rgba(0,0,0,.15)}._3ERQW{padding:0 15px 15px}._38b_4{width:300px}._3s_xP{width:calc(100% - 330px);padding:15px 15px 0 0}.axr90{margin-bottom:20px}._1SrTv{position:absolute;display:inline-block;border:1px solid #ccc;border-radius:2px;font-size:12px;font-weight:400;text-decoration:none;color:#000;text-align:center;padding:6px 25px;right:15px;bottom:15px;cursor:pointer}._1SrTv:hover{border:1px solid #2196f3;color:#2196f3}._1F7nj{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"root": "_2WBLh",
	"flexRow": "_1BJXD flexRow",
	"divider": "_3yFbM",
	"infoBlock": "_3ERQW",
	"left": "_38b_4",
	"right": "_3s_xP",
	"youtubeVideo": "axr90",
	"allVideos": "_1SrTv",
	"vinLeasingBlock": "_1F7nj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/advert/components/CarInfo/CarInfo.css
// module id = 3311
// module chunks = 32